import React from 'react';
import LocationTemplate from './LocationTemplate';

const PollocksvillePage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Pollocksville"
      stateName="North Carolina"
      countyName="Jones"
      zipCodes={["28573"]}
      latitude={35.0124}
      longitude={-77.2236}
      population={311}
      historicalFact="Named after Thomas Pollock, colonial governor of North Carolina."
      nearbyTowns={[
        "Maysville, NC",
        "New Bern, NC",
        "Kinston, NC",
        "Trenton, NC",
        "Jacksonville, NC",
        "Dover, NC",
        "Cove City, NC",
        "La Grange, NC"
      ]}
    />
  );
};

export default PollocksvillePage;